import gql from "graphql-tag";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

const GQLAddErrorlog = gql`
  mutation createerrorlog($error: String, $pageurl: String, $date: String) {
    createerrorlog(error: $error, pageurl: $pageurl, date: $date) {
      success
      message
    }
  }
`;

async function createerrorlog(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddErrorlog,
        variables: {
          error: adddata.error,
          pageurl: adddata.pageurl,
          date: adddata.date,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export { createerrorlog };
